"use strict";
var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var _InteractionManager_deletionInteractionHandler, _InteractionManager_drawingToolsManager, _InteractionManager_geometryMathManager, _InteractionManager_insertionInteractionHandler, _InteractionManager_interactionManagerHelper, _InteractionManager_midPointInteractionHandler, _InteractionManager_restrictionManager, _InteractionManager_viewport, _InteractionManager_cameraFreezeFlag, _InteractionManager_lastEvent, _InteractionManager_onDownPointer;
Object.defineProperty(exports, "__esModule", { value: true });
exports.InteractionManager = void 0;
const viewer_1 = require("@shapediver/viewer");
const viewer_rendering_engine_intersection_restriction_engine_1 = require("@shapediver/viewer.rendering-engine.intersection-restriction-engine");
const viewer_shared_services_1 = require("@shapediver/viewer.shared.services");
const DeletionInteractionHandler_1 = require("./handlers/DeletionInteractionHandler");
const InsertionInteractionHandler_1 = require("./handlers/InsertionInteractionHandler");
const MidPointInteractionHandler_1 = require("./handlers/MidPointInteractionHandler");
const InteractionManagerHelper_1 = require("./helpers/InteractionManagerHelper");
class InteractionManager {
    // #endregion Properties (11)
    // #region Constructors (1)
    constructor(drawingToolsManager) {
        // #region Properties (11)
        _InteractionManager_deletionInteractionHandler.set(this, void 0);
        _InteractionManager_drawingToolsManager.set(this, void 0);
        _InteractionManager_geometryMathManager.set(this, void 0);
        _InteractionManager_insertionInteractionHandler.set(this, void 0);
        _InteractionManager_interactionManagerHelper.set(this, void 0);
        _InteractionManager_midPointInteractionHandler.set(this, void 0);
        _InteractionManager_restrictionManager.set(this, void 0);
        _InteractionManager_viewport.set(this, void 0);
        _InteractionManager_cameraFreezeFlag.set(this, "");
        _InteractionManager_lastEvent.set(this, void 0);
        _InteractionManager_onDownPointer.set(this, void 0);
        __classPrivateFieldSet(this, _InteractionManager_drawingToolsManager, drawingToolsManager, "f");
        __classPrivateFieldSet(this, _InteractionManager_viewport, drawingToolsManager.viewport, "f");
        __classPrivateFieldSet(this, _InteractionManager_geometryMathManager, __classPrivateFieldGet(this, _InteractionManager_drawingToolsManager, "f").geometryMathManager, "f");
        const restrictionsArray = [];
        for (const restrictionId in __classPrivateFieldGet(this, _InteractionManager_drawingToolsManager, "f").settings
            .restrictions) {
            const restriction = __classPrivateFieldGet(this, _InteractionManager_drawingToolsManager, "f").settings.restrictions[restrictionId];
            if (!restriction.id)
                restriction.id = restrictionId;
            restrictionsArray.push(restriction);
        }
        __classPrivateFieldSet(this, _InteractionManager_restrictionManager, new viewer_rendering_engine_intersection_restriction_engine_1.RestrictionManager(__classPrivateFieldGet(this, _InteractionManager_drawingToolsManager, "f").viewport, __classPrivateFieldGet(this, _InteractionManager_drawingToolsManager, "f").parentNode, restrictionsArray, __classPrivateFieldGet(this, _InteractionManager_drawingToolsManager, "f").settings.visualization), "f");
        __classPrivateFieldSet(this, _InteractionManager_deletionInteractionHandler, new DeletionInteractionHandler_1.DeletionInteractionHandler(__classPrivateFieldGet(this, _InteractionManager_drawingToolsManager, "f"), this), "f");
        __classPrivateFieldSet(this, _InteractionManager_insertionInteractionHandler, new InsertionInteractionHandler_1.InsertionInteractionHandler(__classPrivateFieldGet(this, _InteractionManager_drawingToolsManager, "f"), this), "f");
        __classPrivateFieldSet(this, _InteractionManager_midPointInteractionHandler, new MidPointInteractionHandler_1.MidPointInteractionHandler(__classPrivateFieldGet(this, _InteractionManager_drawingToolsManager, "f"), this), "f");
        __classPrivateFieldSet(this, _InteractionManager_interactionManagerHelper, new InteractionManagerHelper_1.InteractionManagerHelper(__classPrivateFieldGet(this, _InteractionManager_drawingToolsManager, "f"), this), "f");
        (0, viewer_1.addListener)(viewer_shared_services_1.EVENTTYPE_DRAWING_TOOLS.ADDED, (e) => {
            const event = e;
            this.addPoint(event.index);
        });
        (0, viewer_1.addListener)(viewer_shared_services_1.EVENTTYPE_DRAWING_TOOLS.REMOVED, (e) => {
            const event = e;
            this.removePoint(event.index);
        });
    }
    // #endregion Constructors (1)
    // #region Public Getters And Setters (4)
    get deletionInteractionHandler() {
        return __classPrivateFieldGet(this, _InteractionManager_deletionInteractionHandler, "f");
    }
    get insertionInteractionHandler() {
        return __classPrivateFieldGet(this, _InteractionManager_insertionInteractionHandler, "f");
    }
    get midPointInteractionHandler() {
        return __classPrivateFieldGet(this, _InteractionManager_midPointInteractionHandler, "f");
    }
    get restrictionManager() {
        return __classPrivateFieldGet(this, _InteractionManager_restrictionManager, "f");
    }
    // #endregion Public Getters And Setters (4)
    // #region Public Methods (10)
    addPoint(insertionIndex) {
        __classPrivateFieldGet(this, _InteractionManager_interactionManagerHelper, "f").addPoint(insertionIndex);
    }
    close() {
        if (__classPrivateFieldGet(this, _InteractionManager_cameraFreezeFlag, "f"))
            __classPrivateFieldGet(this, _InteractionManager_viewport, "f").removeFlag(__classPrivateFieldGet(this, _InteractionManager_cameraFreezeFlag, "f"));
        document.body.style.cursor = "default";
        __classPrivateFieldGet(this, _InteractionManager_interactionManagerHelper, "f").close();
        __classPrivateFieldGet(this, _InteractionManager_restrictionManager, "f").close();
    }
    deleteSelection() {
        __classPrivateFieldGet(this, _InteractionManager_deletionInteractionHandler, "f").deleteSelection(__classPrivateFieldGet(this, _InteractionManager_interactionManagerHelper, "f").selectedPointIndices);
    }
    onDown(event, ray) {
        if (__classPrivateFieldGet(this, _InteractionManager_drawingToolsManager, "f").closed)
            return;
        if (event.button === 0) {
            __classPrivateFieldSet(this, _InteractionManager_onDownPointer, event, "f");
            __classPrivateFieldGet(this, _InteractionManager_interactionManagerHelper, "f").moving = false;
            /**
             * IF INSERT KEY IS PRESSED
             * FINALIZE INSERTION AND START A NEW ONE
             */
            if (__classPrivateFieldGet(this, _InteractionManager_insertionInteractionHandler, "f").insertionActive === true) {
                const result = __classPrivateFieldGet(this, _InteractionManager_insertionInteractionHandler, "f").finalizeInsertion();
                const distances = __classPrivateFieldGet(this, _InteractionManager_geometryMathManager, "f").checkPointDistances(ray, __classPrivateFieldGet(this, _InteractionManager_drawingToolsManager, "f").positionArray);
                __classPrivateFieldGet(this, _InteractionManager_interactionManagerHelper, "f").checkHover(distances, ray);
                if (result) {
                    __classPrivateFieldGet(this, _InteractionManager_drawingToolsManager, "f").update();
                    return;
                }
                else {
                    __classPrivateFieldGet(this, _InteractionManager_insertionInteractionHandler, "f").startInsertion(event);
                    return;
                }
            }
            const distances = __classPrivateFieldGet(this, _InteractionManager_geometryMathManager, "f").checkPointDistances(ray, __classPrivateFieldGet(this, _InteractionManager_drawingToolsManager, "f").positionArray);
            /**
             * IF MID POINT INSERTION IS ACTIVE
             * FINISH MID POINT INSERTION IF THE CURRENT INDEX IS THE MID POINT INSERTION INDEX
             */
            if (__classPrivateFieldGet(this, _InteractionManager_midPointInteractionHandler, "f").midPointInsertionActive ===
                true) {
                __classPrivateFieldGet(this, _InteractionManager_midPointInteractionHandler, "f").finishMidPointInsertion(distances);
                __classPrivateFieldGet(this, _InteractionManager_interactionManagerHelper, "f").midPointInserted = true;
            }
            /**
             * CHECK HOVERED POINT
             */
            __classPrivateFieldGet(this, _InteractionManager_interactionManagerHelper, "f").checkHover(distances, ray);
            /**
             * IF THERE IS A POINT CLOSE TO THE RAY
             */
            __classPrivateFieldGet(this, _InteractionManager_interactionManagerHelper, "f").selectPoint(distances);
            /**
             * IF THE CURRENTLY HOVERED POINT IS SELECTED
             * START DRAGGING
             */
            const draggingStarted = __classPrivateFieldGet(this, _InteractionManager_interactionManagerHelper, "f").startDragging();
            if (draggingStarted && !__classPrivateFieldGet(this, _InteractionManager_cameraFreezeFlag, "f"))
                __classPrivateFieldSet(this, _InteractionManager_cameraFreezeFlag, __classPrivateFieldGet(this, _InteractionManager_viewport, "f").addFlag(viewer_1.FLAG_TYPE.CAMERA_FREEZE), "f");
        }
        else if (event.button === 2) {
            /**
             * WHEN RIGHT MOUSE BUTTON IS PRESSED
             */
            this.onOut();
        }
    }
    /**
     * On mouse move, move the selected point if there is one
     *
     * @param event
     * @param ray
     */
    onMove(event, ray) {
        if (__classPrivateFieldGet(this, _InteractionManager_drawingToolsManager, "f").closed)
            return;
        let currentRestrictedPoint;
        // if there are no points, start with the insertion right away
        if (__classPrivateFieldGet(this, _InteractionManager_drawingToolsManager, "f").settings.general.autoStart &&
            __classPrivateFieldGet(this, _InteractionManager_insertionInteractionHandler, "f").insertionActive === false &&
            __classPrivateFieldGet(this, _InteractionManager_drawingToolsManager, "f").getPointsData().length === 0) {
            __classPrivateFieldSet(this, _InteractionManager_lastEvent, event, "f");
            currentRestrictedPoint =
                this.startInsertion() || currentRestrictedPoint;
        }
        // if the insertion was paused, try to start it again
        // it might not start if the ray is not intersecting with the restriction
        if (__classPrivateFieldGet(this, _InteractionManager_insertionInteractionHandler, "f").insertionPaused) {
            __classPrivateFieldSet(this, _InteractionManager_lastEvent, event, "f");
            currentRestrictedPoint =
                this.startInsertion() || currentRestrictedPoint;
        }
        const distanceSquared = __classPrivateFieldGet(this, _InteractionManager_onDownPointer, "f")
            ? Math.pow(event.clientX - __classPrivateFieldGet(this, _InteractionManager_onDownPointer, "f").clientX, 2) +
                Math.pow(event.clientY - __classPrivateFieldGet(this, _InteractionManager_onDownPointer, "f").clientY, 2)
            : Infinity;
        const clickThresholdSquared = 25;
        const pointerMoved = distanceSquared > clickThresholdSquared;
        __classPrivateFieldGet(this, _InteractionManager_interactionManagerHelper, "f").moving = pointerMoved;
        if (pointerMoved) {
            __classPrivateFieldSet(this, _InteractionManager_lastEvent, event, "f");
            /**
             * IF WE ARE DRAGGING A POINT
             * MOVE THE SELECTED POINTS
             */
            currentRestrictedPoint =
                __classPrivateFieldGet(this, _InteractionManager_interactionManagerHelper, "f").moveSelectedPoints(ray) ||
                    currentRestrictedPoint;
        }
        const distances = __classPrivateFieldGet(this, _InteractionManager_geometryMathManager, "f").checkPointDistances(ray, __classPrivateFieldGet(this, _InteractionManager_drawingToolsManager, "f").positionArray);
        __classPrivateFieldGet(this, _InteractionManager_interactionManagerHelper, "f").checkHover(distances, ray);
        if (pointerMoved) {
            /**
             * IF INSERT KEY IS PRESSED
             * ADD POINT AT RAY INTERSECTION IF THERE IS NONE WAS ADDED
             * MOVE LAST ADDED POINT IF THERE IS ONE
             */
            currentRestrictedPoint =
                __classPrivateFieldGet(this, _InteractionManager_insertionInteractionHandler, "f").onMove(ray) ||
                    currentRestrictedPoint;
            /**
             * IF INSERT KEY IS NOT PRESSED AND DRAGGING IS NOT ACTIVE
             * CHECK IF THERE IS A LINE CLOSE TO THE RAY AND ADD A MID POINT TO IT
             */
            if (__classPrivateFieldGet(this, _InteractionManager_insertionInteractionHandler, "f").insertionActive === false &&
                __classPrivateFieldGet(this, _InteractionManager_interactionManagerHelper, "f").dragging === false &&
                __classPrivateFieldGet(this, _InteractionManager_interactionManagerHelper, "f").selectedPointIndices.length === 0) {
                __classPrivateFieldGet(this, _InteractionManager_midPointInteractionHandler, "f").onMove(ray, __classPrivateFieldGet(this, _InteractionManager_interactionManagerHelper, "f").hoveredPoint);
            }
        }
        if (__classPrivateFieldGet(this, _InteractionManager_interactionManagerHelper, "f").dragging) {
            document.body.style.cursor = "grabbing";
        }
        else if (__classPrivateFieldGet(this, _InteractionManager_interactionManagerHelper, "f").hoveredPoint !== undefined) {
            document.body.style.cursor = "pointer";
        }
        else {
            document.body.style.cursor = "default";
        }
        // if the insertion is active, but the current point is not restricted, pause the insertion
        if (!currentRestrictedPoint &&
            __classPrivateFieldGet(this, _InteractionManager_insertionInteractionHandler, "f").insertionActive)
            __classPrivateFieldGet(this, _InteractionManager_insertionInteractionHandler, "f").pauseInsertion();
        __classPrivateFieldGet(this, _InteractionManager_drawingToolsManager, "f").textVisualizationManager.updatePointerPosition(currentRestrictedPoint);
    }
    /**
     * On mouse out, deselect the hovered point and remove the stop dragging
     */
    onOut() {
        __classPrivateFieldGet(this, _InteractionManager_restrictionManager, "f").showRestrictionVisualization = false;
        __classPrivateFieldGet(this, _InteractionManager_insertionInteractionHandler, "f").pauseInsertion();
        __classPrivateFieldGet(this, _InteractionManager_interactionManagerHelper, "f").onOut();
        this.reset();
    }
    /**
     * On mouse up, check if a point is close to the ray and deselect it
     */
    onUp() {
        if (__classPrivateFieldGet(this, _InteractionManager_drawingToolsManager, "f").closed)
            return;
        __classPrivateFieldGet(this, _InteractionManager_interactionManagerHelper, "f").onUp();
        this.reset();
    }
    removePoint(index) {
        __classPrivateFieldGet(this, _InteractionManager_interactionManagerHelper, "f").removePoint(index);
    }
    startInsertion() {
        __classPrivateFieldGet(this, _InteractionManager_restrictionManager, "f").showRestrictionVisualization = true;
        __classPrivateFieldGet(this, _InteractionManager_midPointInteractionHandler, "f").stopMidPointInsertion();
        return __classPrivateFieldGet(this, _InteractionManager_insertionInteractionHandler, "f").startInsertion(__classPrivateFieldGet(this, _InteractionManager_lastEvent, "f"));
    }
    stopInsertion() {
        __classPrivateFieldGet(this, _InteractionManager_restrictionManager, "f").showRestrictionVisualization = false;
        __classPrivateFieldGet(this, _InteractionManager_insertionInteractionHandler, "f").stopInsertion();
        __classPrivateFieldGet(this, _InteractionManager_viewport, "f").removeFlag(__classPrivateFieldGet(this, _InteractionManager_cameraFreezeFlag, "f"));
        __classPrivateFieldSet(this, _InteractionManager_cameraFreezeFlag, "", "f");
    }
    // #endregion Public Methods (10)
    // #region Private Methods (1)
    reset() {
        if (__classPrivateFieldGet(this, _InteractionManager_insertionInteractionHandler, "f").insertionActive === false) {
            __classPrivateFieldGet(this, _InteractionManager_restrictionManager, "f").showRestrictionVisualization = false;
            __classPrivateFieldGet(this, _InteractionManager_viewport, "f").removeFlag(__classPrivateFieldGet(this, _InteractionManager_cameraFreezeFlag, "f"));
            __classPrivateFieldSet(this, _InteractionManager_cameraFreezeFlag, "", "f");
        }
        __classPrivateFieldGet(this, _InteractionManager_interactionManagerHelper, "f").reset();
    }
}
exports.InteractionManager = InteractionManager;
_InteractionManager_deletionInteractionHandler = new WeakMap(), _InteractionManager_drawingToolsManager = new WeakMap(), _InteractionManager_geometryMathManager = new WeakMap(), _InteractionManager_insertionInteractionHandler = new WeakMap(), _InteractionManager_interactionManagerHelper = new WeakMap(), _InteractionManager_midPointInteractionHandler = new WeakMap(), _InteractionManager_restrictionManager = new WeakMap(), _InteractionManager_viewport = new WeakMap(), _InteractionManager_cameraFreezeFlag = new WeakMap(), _InteractionManager_lastEvent = new WeakMap(), _InteractionManager_onDownPointer = new WeakMap();
//# sourceMappingURL=InteractionManager.js.map